<template>
  <div class="tw-flex tw-items-center">
    <o-dropdown
      v-model="selected"
      aria-role="list"
    >
      <button
        slot="trigger"
        slot-scope="{ active }"
        :disabled="!isActive"
        class="tw-cursor-pointer tw-p-3 tw-bg-white tw-shadow-sm tw-rounded-lg tw-text-[#F1583D]
        tw-flex tw-items-center tw-justify-between tw-font-medium tw-whitespace-nowrap tw-border
        tw-border-solid tw-border-[#DFE2E7] disabled:tw-bg-white disabled:tw-text-[#B3B9C6]
        disabled:tw-cursor-not-allowed"
      >
        {{ selected?.label || 'Select risk level manually' }}
        <i class="fas fa-chevron-down tw-ml-2" />
      </button>

      <o-dropdown-item
        v-for="option in options"
        :key="option.label"
        :value="option"
        variant="primary"
        aria-role="listitem"
      >
        <span>{{ option.label }}</span>
      </o-dropdown-item>
    </o-dropdown>
    <i
      v-if="selected"
      class="fa fa-times tw-px-2 tw-text-gray-400 tw-cursor-pointer"
      title="Clear risk selection"
      @click="selected = null"
    />
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { RISK_LEVELS } from '@frontend/ui/features/checkup/helpers/checkupFunctions.js';

import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'ClientRiskDropdown',
  components: { /* Subcomponents */ },
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: null,
      options: RISK_LEVELS,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useCheckupStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    selected() {
      this.checkupStore.setManualClientRisk(this.selected);
    },
  },
  created() {
    // Initialize selected with manualClientRisk from the store if it exists
    const manualClientRisk = this.checkupStore.manualClientRisk;
    if (manualClientRisk) {
      this.selected = this.options.find(option => option.value === manualClientRisk.value) || null;
    }
  },
  methods: {
    handleChange(value) {
      console.log('change', value);
    },
    handleInput(value) {
      console.log('input', value);
    },
  },
};
</script>


<style scoped>

</style>
